// Owner: P1 piece 8 "Suppression, audit, admin part 1 and the net command" (docs/FILE-OWNERSHIP.md).
// The feature's entry file (docs/CONTRACTS.md section 16): Admin at /admin, one lazy chunk. The chosen tab is the URL's
// `tab` search value (a word from a closed list, never free text). Admin has no go-to key: it opens from the rail's
// foot and from the omnibar (plan section E). The entry is `ownerOnly`, so a member's rail, phone menu and omnibar
// leave it out.
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { ShieldCheck } from 'lucide-react'
import type { Feature } from '../feature.ts'
import { parseSearch } from './tabs.ts'

export const feature: Feature = {
  app: (parent) => [
    createRoute({
      getParentRoute: () => parent,
      path: '/admin',
      validateSearch: (search: Record<string, unknown>) => parseSearch(search),
      component: lazyRouteComponent(() => import('./AdminScreen.tsx')),
    }),
  ],
  nav: [{ to: '/admin', label: 'nav.admin', icon: ShieldCheck, group: 'system', ownerOnly: true }],
}
